import {Component, Input, OnInit} from '@angular/core';
import {Brick} from "./brick";

@Component({
  selector: 'app-brick',
  templateUrl: './brick.component.html',
  styleUrls: ['./brick.component.css']
})
export class BrickComponent implements OnInit {

  @Input() brick: Brick;
  @Input() size = 30;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    return {
      width: `${this.size}px`,
      height: `${this.size/2-1}px`,
    }
  }

}
